import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faCheck,
  faDownload,
  faHome,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { getAllWoDispenserList } from "../../Service/AllWorkOrder";
import moment from "moment";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

export default (props) => {
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [entries, setEntries] = useState([]);
  //Pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const [offset, setOffset] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  // const [location, setLocation] = useState({ latitude: null, longitude: null });
  // const [userAllowed, setUserAllowed] = useState(false);
  // const [errorMessage, setErrorMessage] = useState('');
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const history = useHistory();

  useEffect(() => {
    getDispenserNo(); // Function call to get Installation list
    // eslint-disable-next-line
  }, []);

  const handlePageChange = async (page) => {
    let selectedPage = page - 1;
    setEntries([]);
    const role = sessionStorage.getItem("role");
    const fkUserId = sessionStorage.getItem("pkUserId");
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const status = ["open"];
    // setisLoaded(true);
    await getAllWoDispenserList(
      selectedPage,
      "installation",
      fkUserId,
      role,
      headers,
      status
    )
      .then((result) => {
        setisLoaded(false);
        console.log("Get Pagination DispenserNo Result", result.data);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          entries.map((item, index) => (item.id = totalSize + index + 1));
          console.log("totalSize", totalSize);
          console.log("data", data);
          setEntries(data);
          setTotaloffset(totalSize);
          setTotalCount(result.data.totalElements);

        } else {
          setisLoaded(false);
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    console.log("entries", entries);
  };

  const getDispenserNo = async () => {
    const role = sessionStorage.getItem("role");
    const fkUserId = sessionStorage.getItem("pkUserId");
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const status = ["open"];
    setisLoaded(true);
    await getAllWoDispenserList(
      currentPage,
      "installation",
      fkUserId,
      role,
      headers,
      status
    )
      .then((result) => {
        setisLoaded(false);
        console.log("Work Order installation Result List", result.data);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotalCount(result.data.totalElements);

        } else {
          setEntries([]);
          setPageCount();
          setTotalCount();
        }
      })
      .catch((error) => {
        console.log("Work Order installation Error", error);
      });
  };

  const sendData = (data) => {
    console.log("data :-", data);
    history.push({
      pathname: "/serviceModule/installation",
      state: { data },
    });
  };

  // const sendData = (data) => {
  //   // Attempt to fetch the user's location first
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         // Handle success: Log location and proceed with original logic
  //         const { latitude, longitude } = position.coords;
  //         console.log(`Latitude: ${latitude}, Longitude: ${longitude}`); // Log location to console

  //         // Set location state (optional)
  //         setLocation({ latitude, longitude });
  //         setUserAllowed(true);

  //         // Original navigation logic after successfully fetching location
  //         console.log("data :-", data);
  //         history.push({
  //           pathname: "/serviceModule/installation",
  //           state: { data, location: { latitude, longitude } }, // Pass location along with data if needed
  //         });
  //       },
  //       (error) => {
  //         // Handle error: Log error or show a message
  //         console.error("Error fetching location", error);
  //         setErrorMessage(error.message);
  //         setUserAllowed(false);

  //         // Optionally, proceed without location or inform the user
  //    swal('Location access is required for this feature.');
  //       }
  //     );
  //   } else {
  //     alert("Geolocation is not supported by this browser.");
  //   }
  // };


  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of installation list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "status",
      text: "Status",
      editable: false,
      style: {
        textTransform: "capitalize",
      },
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser Sr No",
      editable: false,
    },
    {
      dataField: "workOrderSerialNo",
      text: "Work Order Sr No",
      editable: false,
    },

    {
      dataField: "dispenserType",
      text: "Dispenser Config",
      editable: false,
    },
    {
      dataField: "installationDate",
      text: "Date",
      editable: false,
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "installationTime",
      text: "Time",
      editable: false,
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
    },
    {
      dataField: "Action",
      text: "Action",
      editable: false,
      formatter: (_, cell) => {
        return (
          <>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => sendData(cell)}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              Fill Installation WO
            </button>
          </>
        );
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <div>
      Showing {from} to {to} of {size} entries
    </div>
  );

  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <ToolkitProvider
          keyField="id"
          search={true}
          columns={columns}
          data={entries}
          exportCSV
        >
          {({ baseProps, searchProps, csvProps }) => (
            <Paginator.PaginationProvider
              pagination={Pagination({
                custom: true,
                alwaysShowAllBtns: true,
                totalSize: totalCount,
                paginationTotalRenderer: customTotal,
                onPageChange: (page) => {
                  handlePageChange(page);
                },
              })}
            >
              {({ paginationProps, paginationTableProps }) => (
                <Card>
                  <div className="table-responsive py-2">
                    <Card.Header>
                      <Row>
                        <Col xs={12} md={6} className="py-1"></Col>
                        <h5 className="head ">Installation work-orders </h5>
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex justify-content-md-end py-1"
                        ></Col>
                      </Row>
                    </Card.Header>

                    <Table
                      {...baseProps}
                      {...paginationTableProps}
                      bodyClasses="border-0"
                      rowClasses="border-bottom"
                      classes="table-flush dataTable-table"
                      remote={{ pagination: true }}
                      cellEdit={cellEditFactory({ mode: "click" })}
                      wrapperClasses="table-responsive"
                      headerClasses="header-class"
                    />
                    <Card.Footer>
                      <Row>
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex align-items-center py-1"
                        ></Col>
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                        >
                          <Paginator.PaginationListStandalone
                            {...paginationProps}
                          />
                        </Col>
                      </Row>
                    </Card.Footer>
                  </div>
                </Card>
              )}
            </Paginator.PaginationProvider>
          )}
        </ToolkitProvider>
      )}
    </>
  );
};
